/* eslint-disable react/require-default-props */
import { useCallback, useContext } from 'react';
import { TiPrinter } from 'react-icons/ti';
import ReactTooltip from 'react-tooltip';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../actions/auth-context';
import { startPlotterTheOrder } from '../../../../actions/order.service';

const StartPlotterOrderButton = ({ order, getOrders }) => {
  const { hasPermissions } = useContext(AuthContext);

  const getPlotterOrder = useCallback(async (data) => {
    startPlotterTheOrder(data.id, {
      action_note: null,
    }).then(() => {
      getOrders();
    });
  }, []);

  const hasViewButton = useCallback(
    () =>
      order.has_plotter &&
      hasPermissions(['edit_order', 'plotter_photos']) &&
      order.order_status === 'Impresso',
    [order]
  );

  return (
    <>
      {hasViewButton() && (
        <TiPrinter
          size={25}
          className="mb-1 action"
          data-tip="Plotter Pedido"
          onClick={() => getPlotterOrder(order)}
        />
      )}

      <ReactTooltip />
    </>
  );
};

StartPlotterOrderButton.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    products: PropTypes.arrayOf(Object),
    order_status: PropTypes.string,
    has_plotter: PropTypes.bool,
  }).isRequired,
  getOrders: PropTypes.func,
};

export default StartPlotterOrderButton;
